/*
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-01-11 15:35:57
 * @LastEditTime: 2019-03-18 16:26:08
 */
import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import permission from "./modules/permission";
import menu from "./modules/menu";

import getters from "./getters";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        user,
        permission,
        menu
    },
    getters
});

export default store;
